import ClientBase from "../ClientBase";
import InspectionAreaMarker from "@/domain/marker/InspectionAreaMarker";

class InspectionZoneClient extends ClientBase {

    async getInspectionAreasByScanId(scanId){
        const data = await this.getAllPaged(`api/v1/inspectionareas/scans/${scanId}`);
        return data?.map(area => new InspectionAreaMarker(area)) ?? [];
    }

    async getInspectionAreasByAssetId(assetId){
        const data = await this.getAllPaged(`api/v1/inspectionareas/assets/${assetId}`);
        return data?.map(area => new InspectionAreaMarker(area)) ?? [];
    }

    async getInspectionAreaMarkersByAssetIdAsync(assetId){
        const data = await this.getAllPaged(`api/v1/inspectionareas/assets/${assetId}`);
        return data?.map(area => new InspectionAreaMarker(area)) ?? [];
    }

    async getInspectionZoneByScanId(scanId, id) {
        const data = await this.get(`api/v1/inspectionareas/scans/${scanId}/${id}`);
        return data ? new InspectionAreaMarker(data) : null;
    }

    async createInspectionArea(newArea) {
        const data = await this.post('api/v1/inspectionareas', newArea);
        return data ? new InspectionAreaMarker(data) : null;
    }

    async updateInspectionArea(area) {
        const data = await this.put(`api/v1/inspectionareas/scans/${area.scanId}/${area.id}`, area, { headers: { 'If-Match': area.eTag } });
        return data ? new InspectionAreaMarker(data) : null;
    }

    async deleteInspectionZone(scanId, id) {
        return await this.delete(`api/v1/inspectionareas/scans/${scanId}/${id}`);
    }
}

export default new InspectionZoneClient();
